import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import {GOOGLE_SEARCH} from '../../utils/constants';
import {LocationLink} from '../common/location-link';
import {Phones} from '../phones';
import {SberbankInfo} from '../sberbank-info';

import classes from './index.module.css';

const renderPhones = (data, maxItems) => (
  data.length
    ? (
      <div className={classes.infoBlock}>
        <p className={classes.infoTitle}>Телефон</p>
        <Phones
          phones={data}
          maxItems={maxItems}
          classStyles={classes.branchPhone}
        />
      </div>
    )
    : null
);

export const BranchPopup = ({data: {branchData, bank}}) => (
  <>
    <div className={classes.logo}>
      <img
        src={bank.bankLogoUrl}
        width={48}
        height={48}
        alt={bank.bankTitle}
      />
      <span className={classes.bankName}>
        {bank.bankTitle}
      </span>
    </div>

    <div className={classes.infoBlock}>
      <p className={classes.infoTitle}>
        Отделение
      </p>
      <span className={classes.branchAddress}>
        {branchData.address}
      </span>
    </div>

    {renderPhones(branchData.phones, 3)}

    {/* Only Sberbank block*/}
    {bank.gradedRates?.length ?
      <>
        <div className={classes.infoBlock}>
          <p className={classes.infoTitle}>
            Градация курса покупки
          </p>
          <SberbankInfo
            gradesList={bank.gradedRates}
            operation='buy'
            classStyles={classes.sberbank}
          />
        </div>
        <div className={classes.infoBlock}>
          <p className={classes.infoTitle}>
            Градация курса продажи
          </p>
          <SberbankInfo
            gradesList={bank.gradedRates}
            operation='sell'
            classStyles={classes.sberbank}
          />
        </div>
      </>
      : null}

    {branchData?.location
      ? (
        <LocationLink
          link={`${GOOGLE_SEARCH}&query=${branchData.location.lat},${branchData.location.lng}`}
          text='Показать на карте'
          style={classes.showOnMap}
        />
      )
      : null
    }
  </>
);

BranchPopup.propTypes = {
  data: PropTypes.shape({
    branchData: PropTypes.shape({
      address: PropTypes.string,
      phones: PropTypes.arrayOf(PropTypes.string),
      location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number
      })
    }),
    bank: PropTypes.shape({
      bankLogoUrl: PropTypes.string,
      bankTitle: PropTypes.string,
      buy: PropTypes.number,
      sell: PropTypes.number,
      gradedRates: PropTypes.arrayOf(PropTypes.shape({
        buy: PropTypes.number,
        grade: PropTypes.string,
        sell: PropTypes.number
      }))
    })
  }).isRequired
};
